import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

const CreateTreeFrom = () => import('@/views/trees/TreeForm')
const Map = () => import('@/views/trees/map')
const Tree = () => import('@/views/trees/tree')
const Trees = () => import('@/views/trees/trees')
const DeletedTrees = () => import('@/views/trees/deleted_trees')
const ControlData = () => import('@/views/config/ControlData')
const IntervalRelation = () => import('@/views/config/IntervalRelation')
const Schluessel = () => import('@/views/config/Schluessel')
const DefaultTask = () => import('@/views/config/DefaultTask')
const Controller = () => import('@/views/config/controller')
const Bounds = () => import('@/views/config/bounds')
const Control = () => import('@/views/control/control')
const Controls = () => import('@/views/control/controls')
const AllControls = () => import('@/views/control/all_controls')
const Tours = () => import('@/views/control/control_tours')
const Planning = () => import('@/views/control/tour_planning')
const Plannings = () => import('@/views/control/tour_plannings')
const TreeTasks = () => import('@/views/task/tasks')
const TreeAppointments = () => import('@/views/trees/Appointments.vue')
const AllTasks = () => import('@/views/task/all_tasks')
const AllTasksMap = () => import('@/views/task/all_tasks_map')
const Task = () => import('@/views/task/task')
const TaskPlanning = () => import('@/views/task/task_planning')
const TaskPlannings = () => import('@/views/task/task_plannings')
const Settings = () => import('@/views/config/settings')
const AugrAndWork = () => import('@/views/config/AugrAndWork')
const DefaultLear = () => import('@/views/config/DefaultLear')
const Chat = () => import('@/views/chat/Chat')

Vue.use(Router);

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/tree/trees',
      name: 'Baumkontrolle',
      component: DefaultContainer,
      children: [
        {
          path: 'tree',
          redirect: '/tree/trees',
          name: 'Baueme',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "create",
              name: 'Baum erfassen',
              component: CreateTreeFrom
            },
            {
              path: "show/:id",
              name: 'Baum',
              component: Tree,
            },
            {
              path: "controls/:id",
              name: 'Controls',
              component: Controls
            },
            {
              path: "tasks/:id",
              name: 'TreeTasks',
              component: TreeTasks
            },
            {
              path: "appointments/:id",
              name: 'TreeAppointments',
              component: TreeAppointments
            },
            {
              path: "trees",
              name: 'Trees',
              component: Trees
            },
            {
              path: "deleted_trees",
              name: 'DeletedTrees',
              component: DeletedTrees
            },
            {
              path: "map",
              name: 'map',
              component: Map
            },
          ],
        },
        {
          path: 'control',
          name: 'Control',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "control/:id",
              name: 'Control',
              component: Control
            },
            {
              path: "controls",
              name: 'ControlsAll',
              component: AllControls
            },
            {
              path: "tours",
              name: 'Tours',
              component: Tours
            },
            {
              path: "planning",
              name: 'Tours Planning',
              component: Planning
            },
            {
              path: "plannings",
              name: 'Tours Plannings',
              component: Plannings
            },
          ],
        },
        {
          path: 'tasks',
          name: 'Tasks',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "all",
              name: 'All Tasks',
              component: AllTasks
            },
            {
              path: "map_all",
              name: 'Tasks Map',
              component: AllTasksMap
            },
            {
              path: "planning",
              name: 'Planning Tasks',
              component: TaskPlanning
            },
            {
              path: "plannings",
              name: 'Task Plannings',
              component: TaskPlannings
            },
            {
              path: "task/:id",
              name: 'Task',
              component: Task
            },
          ],
        },
        {
          path: 'config',
          redirect: '/config/data',
          name: 'Voreinstellungen',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "data",
              name: 'Kontroll Schluessel',
              component: ControlData
            },
            {
              path: "interval_relation/:id",
              name: 'Kontrollregeln',
              component: IntervalRelation
            },
            {
              path: "schluessel/:sType",
              name: 'Schlüssel',
              component: Schluessel
            },
            {
              path: "schluessel_task",
              name: 'Standartauftrag',
              component: DefaultTask
            },
            {
              path: "controller",
              name: 'Controller',
              component: Controller
            },
            {
              path: "settings",
              name: 'Settings',
              component: Settings
            },
            {
              path: "bounds",
              name: 'Offline Karte',
              component: Bounds
            },
            {
              path: "augr_work",
              name: 'Stammaufträge',
              component: AugrAndWork
            },
            {
              path: "lear",
              name: 'Leistungsart',
              component: DefaultLear
            }
          ],
        },
        {
          path: 'chat',
          name: 'chat generic',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ":customer_number",
              name: 'Chat',
              component: Chat
            },
          ],
        },
      ]
    },
  ]
})
